"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = (props, isOpen, inputValueAsPercentage) => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    size = 'medium',
    view = 'underline',
    isWithClearButton = false,
    isDisabled = false,
    borderRadius = {}
  } = props;
  const {
    type = 'text',
    width = '100%'
  } = props;
  const {
    pxToRem,
    getMeasurement,
    maskProps,
    fontSizeProps,
    setEndDirection,
    borderRadiusProps
  } = (0, _hooks.useStylesUtils)();
  const ccInputStyle = (0, _react.useMemo)(() => {
    const viewProps = () => {
      if (view === 'underline') {
        return {
          borderBottom: `1px solid ${themeColors?.general.border}`,
          '&:focus': {
            borderBottom: `1px solid ${themeColors?.primary.main}`
          }
        };
      } else {
        return {};
      }
    };
    const rangeProps = () => {
      return {
        background: `linear-gradient(90deg, ${themeColors?.primary.main} 0%, ${themeColors?.primary.main} ${inputValueAsPercentage}%, rgba(112, 112, 112, 0.45) ${inputValueAsPercentage}%, rgba(112, 112, 112, 0.45) 100%)`
      };
    };
    const sliderDeviceProps = () => {
      const height = isMobileView ? pxToRem(6) : pxToRem(2);
      return {
        height
      };
    };
    const typeProps = () => {
      switch (type) {
        case 'text':
          return {
            backgroundColor: 'transparent',
            overflow: 'hidden',
            outline: 'none',
            height: pxToRem(24),
            border: 0,
            ...fontSizeProps(size),
            ...viewProps()
          };
        case 'range':
          return {
            appearance: 'none',
            borderRadius: pxToRem(3),
            background: themeColors?.general.border,
            outline: 'none',
            transition: 'opacity 0.2s',
            direction: 'ltr',
            margin: `${pxToRem(23)} 0`,
            ...rangeProps(),
            ...sliderDeviceProps(),
            '&::-webkit-slider-thumb': {
              appearance: 'none',
              width: pxToRem(20),
              height: pxToRem(20),
              background: themeColors?.primary.main,
              borderRadius: '50%',
              cursor: 'pointer'
            }
          };
        default:
          return {};
      }
    };
    const clearProps = () => {
      const paddingInlineEnd = isWithClearButton ? pxToRem(15) : 0;
      return {
        paddingInlineEnd
      };
    };
    const borderProps = () => {
      if (Object.keys(borderRadius).length !== 0) {
        return {
          border: `1px solid ${themeColors?.general.border}`,
          ...borderRadiusProps(borderRadius),
          padding: `${pxToRem(8)} ${pxToRem(12)}`
        };
      }
      return {};
    };
    const disabledProps = () => {
      if (isDisabled) {
        return {
          opacity: '.5',
          cursor: 'default'
        };
      }
      return {};
    };
    const ccInputMask = (0, _css.css)({
      ...maskProps(isOpen)
    });
    const ccInput = (0, _css.css)({
      position: 'relative',
      userSelect: 'none',
      width: '100%',
      ...disabledProps(),
      ...borderProps()
    });
    const ccInputContent = (0, _css.css)({
      position: 'relative',
      width: '100%'
    });
    const ccInputField = (0, _css.css)({
      fontFamily: fontFamily,
      color: themeColors?.general.text,
      width: getMeasurement(width),
      ...typeProps(),
      ...clearProps()
    });
    const ccInputClearBtn = (0, _css.css)({
      display: 'flex',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      height: pxToRem(10),
      ...setEndDirection(0)
    });
    return {
      ccInputMask,
      ccInput,
      ccInputContent,
      ccInputField,
      ccInputClearBtn
    };
  }, [maskProps, isOpen, fontFamily, themeColors?.general.text, themeColors?.general.border, themeColors?.primary.main, getMeasurement, width, pxToRem, setEndDirection, view, inputValueAsPercentage, isMobileView, type, fontSizeProps, size, isWithClearButton, borderRadius, borderRadiusProps, isDisabled]);
  return {
    'cc-Input-mask': ccInputStyle.ccInputMask,
    'cc-Input': ccInputStyle.ccInput,
    'cc-Input__content': ccInputStyle.ccInputContent,
    'cc-Input__field': ccInputStyle.ccInputField,
    'cc-Input__clear-btn': ccInputStyle.ccInputClearBtn
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;